import { Alert, Badge, Table } from "flowbite-react";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import { formatToReal } from "../../../utils/utils";
import moment from "moment";

const CadastralPF = ({ data }) => {
  const info = data;
  const registration = {
    documentNumber: info?.cpf,
    consumerName: info?.nome,
    motherName: info?.nome_mae,
    birthDate: info?.data_nascimento,
    age: info?.idade,
    gender: info?.genero,
  };

  return (
    <>
      {info?.statusRetorno == 1 ? (
        <>
          {/* Dados Cadastrais */}
          <div className="mt-6 border rounded-2xl shadow p-6 bg-white">
            <h3 className="text-lg font-bold mb-4 border-b pb-2">
              📄 Dados Cadastrais
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700">
              <div>
                <div className="mb-2">
                  <strong>Nome completo:</strong>{" "}
                  {registration?.consumerName || "Indisponível"}
                </div>
                <div className="mb-2">
                  <strong>Nome da mãe:</strong>{" "}
                  {registration?.motherName || "Indisponível"}
                </div>
                <div className="mb-2">
                  <strong>Sexo:</strong>{" "}
                  {registration?.gender === "F" ? "Feminino" : "Masculino"}
                </div>
                <div className="mb-2 flex flex-wrap items-center gap-2">
                  <strong>Data de nascimento:</strong>{" "}
                  {registration?.birthDate || "Indisponível"}
                  {registration?.birthDate && (
                    <span className="bg-primary text-white px-2 py-0.5 rounded-md text-xs font-semibold">
                      {registration?.age} anos
                    </span>
                  )}
                </div>
              </div>
              <div>
                <div className="mb-2">
                  <strong>CPF:</strong>{" "}
                  {registration?.documentNumber || "Indisponível"}
                </div>
                <div className="mb-2">
                  <strong>Situação na Receita:</strong>{" "}
                  {info?.situacao_rf || "Indisponível"}
                </div>
                <div className="mb-2">
                  <strong>Data emissão:</strong>{" "}
                  {info?.data_emissao || "Indisponível"}
                </div>
              </div>
            </div>
          </div>

          {/* Participações Societárias */}
          {info?.sociedade?.length > 0 && (
            <div className="mt-2 border rounded-2xl shadow p-6 bg-white">
              <h3 className="text-lg font-bold mb-4 border-b pb-2">
                🏢 Participações Societárias
              </h3>
              <div className="text-sm text-gray-700">
                {info.sociedade.map((s, idx) => (
                  <div key={idx} className="mb-2">
                    <div>
                      <strong>Empresa:</strong> {s.razao_social} ({s.cnpj})
                    </div>
                    <div>
                      <strong>Cargo:</strong> {s.cargo}
                    </div>
                    <div>
                      <strong>Situação na Receita:</strong> {s.situacao_rf}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Endereço */}
          {info?.localizacao?.length > 0 && (
            <div className="mt-2 border rounded-2xl shadow p-6 bg-white">
              <h3 className="text-lg font-bold mb-4 border-b pb-2">
                📍 Endereço Atual
              </h3>
              <div className="text-sm text-gray-700">
                {info.localizacao.map((e, i) => (
                  <div key={i} className="mb-2">
                    <div>
                      <strong>Logradouro:</strong> {e.tipo_logradouro}{" "}
                      {e.logradouro}, {e.numero}
                    </div>
                    <div>
                      <strong>Complemento:</strong> {e.complemento || "-"}
                    </div>
                    <div>
                      <strong>Bairro:</strong> {e.bairro}
                    </div>
                    <div>
                      <strong>Cidade/UF:</strong> {e.cidade}/{e.uf}
                    </div>
                    <div>
                      <strong>CEP:</strong> {e.cep}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Celulares */}
          {info?.telefone_movel?.length > 0 && (
            <div className="mt-2 border rounded-2xl shadow p-6 bg-white">
              <h3 className="text-lg font-bold mb-4 border-b pb-2">
                📱 Telefones Móveis
              </h3>
              <div className="text-sm text-gray-700">
                {info.telefone_movel.map((t, i) => (
                  <div key={i} className="mb-2">
                    <strong>Telefone:</strong> ({t.ddd}) {t.numero}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Emails */}
          {info?.email?.length > 0 && (
            <div className="mt-2 border rounded-2xl shadow p-6 bg-white">
              <h3 className="text-lg font-bold mb-4 border-b pb-2">
                ✉️ Emails
              </h3>
              <div className="text-sm text-gray-700">
                {info.email.map((e, i) => (
                  <div key={i} className="mb-2">
                    <strong>Email:</strong> {e.email}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Veículo */}
          {info?.veiculo?.length > 0 && (
            <div className="mt-2 border rounded-2xl shadow p-6 bg-white">
              <h3 className="text-lg font-bold mb-4 border-b pb-2">
                🚗 Veículo
              </h3>
              <div className="text-sm text-gray-700">
                {info.veiculo.map((v, i) => (
                  <div key={i} className="mb-2">
                    <div>
                      <strong>Modelo:</strong> {v.fabricante} {v.modelo}
                    </div>
                    <div>
                      <strong>Ano Modelo:</strong> {v.ano_modelo}
                    </div>
                    <div>
                      <strong>Valor FIPE:</strong> {formatToReal(v.valor_fipe)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Relacionamentos */}
          {info?.relacionamento?.length > 0 && (
            <div className="mt-2 border rounded-2xl shadow p-6 bg-white">
              <h3 className="text-lg font-bold mb-4 border-b pb-2">
                👥 Relacionamentos
              </h3>
              <div className="text-sm text-gray-700">
                {info.relacionamento.map((r, idx) => (
                  <div key={idx} className="mb-2">
                    <div>
                      <strong>Grau:</strong> {r.grau_relacao}
                    </div>
                    <div>
                      <strong>Nome:</strong> {r.nome} - <strong>CPF:</strong>{" "}
                      {r.cpf_relacao}
                    </div>
                    <div>
                      <strong>Data de nascimento:</strong> {r.data_nascimento}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      ) : (
        <Alert color="gray" className="mt-4">
          Consulta indisponível no momento.
        </Alert>
      )}
    </>
  );
};

export default CadastralPF;
